// NEW CI&T
// const firebaseConfig = {
//   apiKey: "AIzaSyAVdscyDrkt8Z7NG0VatFj_sB7xQwTaG-I",
//   authDomain: "zdnacloud-dev-d.firebaseapp.com",
//   projectId: "zdnacloud-dev-d",
//   storageBucket: "zdnacloud-dev-d.appspot.com",
//   messagingSenderId: "228419851649",
//   appId: "1:228419851649:web:21e7eab9678ec5f5258480"
// };

const firebaseConfig = {
  apiKey: "AIzaSyBvNSHqopKIhph7yAer8GmBuN3jwwbmGcs",
  authDomain: "zdnacloud-conftool-d-d.firebaseapp.com",
  projectId: "zdnacloud-conftool-d-d",
  storageBucket: "zdnacloud-conftool-d-d.appspot.com",
  messagingSenderId: "97569770125",
  appId: "1:97569770125:web:f32cc4e718dae110b3f0c4"
};

// const firebaseConfig = {
//   apiKey: "AIzaSyAVAr6EJUToRLQpoy4ON1QXOiKIG_1jdEQ",
// 	authDomain: "emc-kr-test-t.firebaseapp.com",
// 	projectId: "emc-kr-test-t",
// 	storageBucket: "emc-kr-test-t.appspot.com",
// 	messagingSenderId: "1067112698504",
// 	appId: "1:1067112698504:web:9682f270fcc4bce32e853d",
// }

// const firebaseConfig = {
//   apiKey: "AIzaSyCOnMKe0xNYcP64cTQc5T3-pjCyG9Lzdq8",
//   authDomain: "dnacloud-poc-t.firebaseapp.com",
//   projectId: "dnacloud-poc-t",
//   storageBucket: "dnacloud-poc-t.appspot.com",
//   messagingSenderId: "807392571422",
//   appId: "1:807392571422:web:9c0c5db2eb86466c703e0f"
// };
export default firebaseConfig;